import React from 'react'
import { TextInput } from './TextInput'
import { InputBaseProps } from './InputBase'
import { Button } from '../buttons/Button'
import { Group } from '../layout/Group'

export interface SearchBoxProps extends InputBaseProps<string> {
    /**
       * Click handler
       */
    onClick: () => void;
}

export const SearchBox: React.FC<SearchBoxProps> = (props) => {
    const { size = "block", disabled = false, ...inputProps } = props;
    const items = [
        { element: <TextInput {...inputProps} disabled={disabled} />, flex: 1 },
        { element: <Button label={<span dangerouslySetInnerHTML={{ __html: '<i class="fas fa-search"></i>' }} />} onClick={props.onClick} /> }
    ];

    return <Group {...props} items={items} />
}